import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { clearAllData } from '@/utils/cleanup';
import { Loader2 } from 'lucide-react';

const withCleanup = <P extends object>(
  WrappedComponent: React.ComponentType<P>
) => {
  const WithCleanupComponent: React.FC<P> = (props) => {
    const [isCleaning, setIsCleaning] = useState(true);

    useEffect(() => {
      const cleanup = async () => {
        try {
          await clearAllData();
        } catch (error) {
          console.error('Falha ao limpar os dados:', error);
          toast.error('Não foi possível limpar a sessão anterior.');
        } finally {
          setIsCleaning(false);
        }
      };

      cleanup();
    }, []);

    if (isCleaning) {
      return (
        <div className="flex h-screen w-full items-center justify-center">
          <Loader2 className="h-16 w-16 animate-spin" />
        </div>
      );
    }

    return <WrappedComponent {...props} />;
  };

  return WithCleanupComponent;
};

export default withCleanup;
